import { render } from "./BaseRoom.vue?vue&type=template&id=52559d78"
import script from "./BaseRoom.vue?vue&type=script&lang=js"
export * from "./BaseRoom.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__